import { Component, OnInit, ViewChild } from "@angular/core";

import { AuthService } from "src/app/core/auth.service";
import {
  TableService,
  TableSchema,
  TableTypes,
  DataTableComponentBase,
  Filter,
} from "@kortobaa-front/k-ng-datatable";

@Component({
  selector: "app-pages-list",
  templateUrl: "./pages-list.component.html",
  styleUrls: ["./pages-list.component.scss"],
})
export class PagesListComponent
  extends DataTableComponentBase
  implements OnInit {
  moduleName = "pages";
  url: string = "pages";

  displayedColumns: TableSchema[] = [
    {
      title: "ID",
      id: "id",
      type: TableTypes.number,
      editable: false,
    },
    {
      title: "url",
      id: "url",
      type: TableTypes.text,
      editable: true,
    },
    {
      title: "Status",
      id: "status",
      type: TableTypes.booleanNumber,
      editable: true,
    },
  ];
  dataSource;
  isDataLoading = false;

  constructor(
    private tableService: TableService,
    public authService: AuthService
  ) {
    super();
    this.tableService.tableUrl = "pages";
  }

  async ngOnInit() {
    //this.dataSource = await this.tableService.getData().pipe(first()).toPromise();
  }

  async getData(filters?: Filter) {
    try {
      this.dataSource = await this.tableService.getData(filters).toPromise();
    } catch (err) {
      // console.error(err);
    }
    this.isDataLoading = false;
  }

  getDataForAction(data) {
    this.tableService.SaveItem(data).subscribe(
      (row: any) => {
        this.tableService.redirect(this.url);
      },
      (error) => {
        alert(error.error.error.message);
      }
    );
    //console.log('from main ',data)
  }
}
